import { create } from 'zustand'
import { createJSONStorage, persist } from 'zustand/middleware'

interface TenantState {
  currentTenant: string | null
  hasHydrated: boolean
  setCurrentTenant: (tenantId: string) => void
  clearTenant: () => void
  setHasHydrated: (hasHydrated: boolean) => void
}

export const useTenantStore = create<TenantState>()(
  persist(
    (set) => ({
      currentTenant: null,
      hasHydrated: false,
      setCurrentTenant: (tenantId: string) => set({ currentTenant: tenantId }),
      clearTenant: () => set({ currentTenant: null }),
      setHasHydrated: (hasHydrated: boolean) => set({ hasHydrated }),
    }),
    {
      name: 'tenant-store',
      storage: createJSONStorage(() => localStorage),
      partialize: (state) => ({ currentTenant: state.currentTenant }),
      onRehydrateStorage: () => (state) => {
        state?.setHasHydrated(true)
      },
    },
  ),
)